var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"controls",on:{"click":function($event){return _vm.emitUpdate()}}},[(_vm.showAdd)?_c('div',{staticClass:"add",on:{"click":function($event){return _vm.emitAdd()}}},[_vm._v("+")]):_vm._e(),(_vm.showRemove)?_c('div',{staticClass:"remove",on:{"click":function($event){return _vm.emitRemove()}}},[_vm._v("-")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }